import { Color } from '../../../../constants'
import { Text } from '../../../../elements'
import { useTranslations } from '../../../../translate'

export const WeekTitle = (props: { week: number; small?: boolean }) => {
  const t = useTranslations()

  return (
    <Text
      color={Color.DARK_GREY}
      size={props.small ? 6 : 5}
      py={props.small ? 0 : 2}
      bold
    >
      {t.ui.week()} {props.week}
    </Text>
  )
}
